<template>
  <div id="app">

    <router-view  v-if="isRouterAlive" ></router-view>
  </div>
</template>
<script>


export default {
  name: "APP",

   provide () {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
       isRouterAlive: true
    };
  },
  	  beforeMount() {
		  	
		  	if(this.isMobile()){
		
		  	  window.location.href="https://lab.sealtech.com/labh5";
			    // window.location.href="http://192.168.11.251:8082/" ;
		  	}
		  						 
		  	
		  	// if(!this.isMobile()){
		  	//    // 跳转
		  	// 				    // window.location.href="https://lab.sealtech.com/";
		  	//   	    
		  	// }
		  },
  mounted: function () {
    let vm = this;


     let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta'); // 这里创建一个
    let meta1 = document.createElement('meta');//
    let title =vm.$i18n.tc('menu.BTitle');
    let key =vm.$i18n.tc('menu.KEYWords');
    let DEs = vm.$i18n.tc('menu.DEscription');
    document.title=title;
    // 设置第一个meta的内容
    meta.name = "KEYWords";
    meta.content =key;

   // 设置第二个meta
    meta1.name = "DEscription";
    meta1.content = DEs;
    // 一个页面只有一个head标签，所以只有head【0】
    head[0].appendChild(meta); // 把第一个meta添加给head
    head[0].appendChild(meta1) // 把第二个 同上
    vm.$root.meta = meta;
    vm.$root.meta1 = meta1;
    
  },
  methods: {
    
  reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    isMobile() {
				      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				      return flag!=null;
				    }
  },
};
</script>

<style lang="less" scoped>

</style>
 